import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'

import Heading from './components/Heading/Heading'
import PricingDetails from './components/PricingDetails'

import icPricetagSVG from 'assets/ic-pricetag.svg'

import classes from './PricingDisplay.module.scss'

/** @type {import("./types").default} */
const PricingDisplay = ({ className, pricing, hasHeading = true, ...props }) => {
  const hasAmount = !!pricing?.amount

  return (
    <div className={clsx(classes.root, [!hasAmount && classes.emptyState], className)} {...props}>
      {hasHeading && <Heading />}

      {hasAmount ? (
        <PricingDetails pricing={pricing} />
      ) : (
        <EmptyState text="No pricing info" img={icPricetagSVG.src} variant="small" />
      )}
    </div>
  )
}

export default PricingDisplay
